import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/schubergphilis.webp';
import screenshot_target from '../../../images/letterfunnel/thijsvanleeuwen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Thijs van Leeuwen"
      firstname="Thijs"
      companyname="Schuberg Philis"
      competition="Sentia en InSpark"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/thijsvanleeuwen.js